import * as PropTypes from 'prop-types';

export const SavedEchecks = PropTypes.arrayOf(
  PropTypes.shape({
    accountNumber: PropTypes.string.isRequired,
    accountType: PropTypes.string.isRequired,
    billingName: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routingNumber: PropTypes.string.isRequired
  })
);
